var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site"},[(!_vm.isMeeting)?_c('MainNavBar',{on:{"logout":_vm.$app.logout}}):_vm._e(),_c('main',{staticClass:"my-6 site__content",class:{
      site__padding: !_vm.isMeeting,
      'gant-together-body': _vm.pathMixin_isMeetingLandingPage,
    }},[_c('router-view')],1),(_vm.$globals.profile.firstName !== '')?_c('AutoLogoutTimer',{staticClass:"pulled-right",on:{"logout":_vm.$app.logout}}):_vm._e(),(!_vm.isMeeting)?_c('MainFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }